import type { FaireProductEntity } from "../../entity_types/product";

export const p_46qxsrvdcj: FaireProductEntity = {
  token: "p_46qxsrvdcj",
  type: "product",
  name: "Jellyfish Squishy – Glitter “Squeeze Mochi” Stress Toy",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/9f8c241263ab3fdf1365f9f10c948b5bcbbde11fae342fe719c976864d762028.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.99,
  description:
    "Meet the Jellyfish Squishy—a sparkly, extra-satisfying squeeze toy with cute jellyfish tentacles and an extra dense feel customers love. It’s soft, slow-rising, and seriously fun to squish, making it a perfect impulse item for checkout counters, gift shops, toy sections, and trend tables.\n\nWhat’s Included\n12pcs Jellyfish Squishy per display\n4 sparkly colors (mix may vary)\n\nWhy It Sells\nPerfect impulse buy next to the register (customers squeeze it once and want one)\nExtra dense “squeeze mochi” feel for an ultra-satisfying squish\nSlow-rising texture for stress relief and sensory play\nGlittery, colorful look makes it feel collectible and giftable\nShips quickly — limited stock available",
  tags: [],
  msrpDollars: 11.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:40.653Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
